/*-------------------------------------------------------------------------------------------------------------------
* about:教程的路由，执行之前需要把路径和参数保存好，执行时把它提取后进行跳转
* author:马兆铿
* date:2018-3-8
* -------------------------------------------------------------------------------------------------------------------*/
import router from "../main";

function TutorialRoute() {
  this.name = 'tutorialRoute';  //session保存的名字

  /*  保存需要跳转的路径和参数
  * */
  this.set = (obj) => {
    if (typeof obj !== 'object') {
      console.error('the type of the parameter must be an object');
    }
    sessionStorage.setItem(this.name, JSON.stringify(obj));
  };

  /*  执行保存的路径和参数跳转
  * */
  this.move = () => {
    let obj = sessionStorage.getItem(this.name);
    if (obj) {
      const routeObj = JSON.parse(obj);
      router.push({
        path: routeObj.path,
        query: routeObj.query,
      });
      sessionStorage.removeItem(this.name);
    }
  };
}

export let tutorialRoute = new TutorialRoute();


// WEBPACK FOOTER //
// ./src/utils/tutorialRoute.js